import React from 'react'
import { Card, CardMedia, CardContent, CardActions, Typography, IconButton } from '@material-ui/core'
import { AddShoppingCart } from '@material-ui/icons'

import useStyles from './style'

const Product = (props) => {
  const classes = useStyles()
  const { product, onAddToCart } = props

  return (
    <Card className={classes.root}>
      <CardMedia className={classes.media} image={product.media.source} title={product.media.type} />
      <CardContent>
        <div className={classes.cardContent}>
          <Typography variant='h6'>
            {product.name}
          </Typography>
          <Typography variant='h6'>
            {product.price.formatted_with_symbol}
          </Typography>
        </div>
        <Typography variant='body2' color='textSecondary'/>
      </CardContent>
      <CardActions disableSpacing className={classes.cardActions}>
        <IconButton aria-label="Add to Cart" onClick={() => onAddToCart(product.id, 1)}>
          <AddShoppingCart />
        </IconButton>
      </CardActions>
    </Card>
  )
}

export default Product
